import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getBoxStyles = (theme: Theme) =>
    css({
        display: 'flex',
        flexDirection: 'column',
        padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
        backgroundColor: theme.palette.white,
        borderRadius: theme.borderRadius.L,
        border: `1px solid ${theme.palette.gray.light}`,
        margin: '0 auto',
        maxWidth: 642,
    });
